import { request } from "../utils/request.js"

export const commodityLossOrder_exportForManage = (pojo, args) => request({
    url: 'commodityLossOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityLossOrder_findPageForManage = (pojo, args) => request({
    url: 'commodityLossOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityLossOrder_findPageListForManage = (pojo, args) => request({
    url: 'commodityLossOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityLossOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'commodityLossOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityLossOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'commodityLossOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const commodityLossOrder_saveIntoDraft = (pojo, args) => request({
    url: 'commodityLossOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityLossOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'commodityLossOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityLossOrder_update = (pojo, args) => request({
    url: 'commodityLossOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityLossOrder_updateAndSubmit = (pojo, args) => request({
    url: 'commodityLossOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityLossOrder_submitById = (id, args) => request({
    url: 'commodityLossOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityLossOrder_deleteById = (id, args) => request({
    url: 'commodityLossOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityLossOrder_approval = (pojo, args) => request({
    url: 'commodityLossOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityLossOrder_findById = (id, args) => request({
    url: 'commodityLossOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commodityLossOrder_findVoById = (id, args) => request({
    url: 'commodityLossOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/commodityLossOrder.js